import { Box } from '@chakra-ui/react';
import { Avatar, AvatarGroup } from '@chakra-ui/react';
export const BulkAvatarActions = ({
  users,
  verb
}) => {
  const userNames = users.map(user => user.name);
  let userSentence;
  if (userNames.length > 2) {
    userSentence = `${userNames[0]}, ${userNames[1]} and ${userNames.length - 2} ${userNames.length - 2 === 1 ? 'other' : 'others'} will be ${verb}`;
  } else if (userNames.length == 2) {
    userSentence = `${userNames[0]} and ${userNames[1]} will be ${verb}`;
  } else {
    userSentence = `${userNames[0]} will be ${verb}`;
  }
  return <Box marginTop="1rem" data-sentry-element="Box" data-sentry-component="BulkAvatarActions" data-sentry-source-file="BulkAvatarActions.tsx">
      <AvatarGroup max={3} data-sentry-element="AvatarGroup" data-sentry-source-file="BulkAvatarActions.tsx">
        {users.map(user => <Avatar key={user.id} alignItems="center" background={!!user.image ? 'transparent' : 'gradient.sunrise'} color="text.primaryWhite" fontWeight="bold" fontFamily="codenext" src={user.image} data-testid="user_avatar" name={user.name} size={'lg'} borderRadius={'50%'} borderWidth="1px" borderColor="cloud.200" />)}
      </AvatarGroup>
      <Box marginTop="0.5rem" data-sentry-element="Box" data-sentry-source-file="BulkAvatarActions.tsx">{userSentence}</Box>
    </Box>;
};